import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import styles from "./SmartBiz.module.scss";

import SmartBizForm from "./SmartBizForm";

// assets
import circleDecor from "./SmartBizWebPageAssets/Circle-01.png";
import heroPhoto from "./SmartBizWebPageAssets/Group 22.png";
import wifiDiagrm2 from "./SmartBizWebPageAssets/Icons-WiFi Connections.png";
import phoneShot from "./SmartBizWebPageAssets/Screen_App.png";
import wifiDiagram from "./SmartBizWebPageAssets/Screen_Dashboard.png";
import appTitleArt from "./SmartBizWebPageAssets/Group 88.png";
import appPhonesArt from "./SmartBizWebPageAssets/Group 87.png";
import wifiStat1 from "./SmartBizWebPageAssets/shutterstock_427841167.png";
import wifiStat2 from "./SmartBizWebPageAssets/shutterstock_1335606317 AI Fill.png";
import mask from "./SmartBizWebPageAssets/Mask Group 1.png";
import mask2 from "./SmartBizWebPageAssets/Mask Group 2.png";
import mask3 from "./SmartBizWebPageAssets/Mask Group 3.png";
import mask4 from "./SmartBizWebPageAssets/Mask Group 4.png";
import mask5 from "./SmartBizWebPageAssets/Mask Group 5.png";
import mask6 from "./SmartBizWebPageAssets/Mask Group 6.png";
import mask7 from "./SmartBizWebPageAssets/Mask Group 7.png";
import mask8 from "./SmartBizWebPageAssets/Mask Group 8.png";
import mask9 from "./SmartBizWebPageAssets/Mask Group 9.png";
import mask10 from "./SmartBizWebPageAssets/Group 117.png";
import mask11 from "./SmartBizWebPageAssets/Group 118.png";
import mask12 from "./SmartBizWebPageAssets/Group 119.png";
import mask13 from "./SmartBizWebPageAssets/Group 120.png";
import mask14 from "./SmartBizWebPageAssets/Group 132.png";
import mask15 from "./SmartBizWebPageAssets/Group 136.png";
import mask16 from "./SmartBizWebPageAssets/Group 140.png";
import { useLocation } from "react-router-dom";

export default function SmartBiz(): React.JSX.Element {
  const pageTitle = ROUTES?.smartBiz?.title ?? "Cityside Fiber SmartBiz";
  const location = useLocation();
  useEffect(() => {
    if (location.hash === "#smartbiz-form") {
      const el = document.getElementById("smartbiz-form");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location]);
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content="Internet solutions built for small & medium businesses: managed WiFi, POS isolation, security, and priority support."
        />
        <link rel="canonical" href="https://www.citysidefiber.com/smartbiz" />
      </Helmet>

      {/* HERO */}
      <section className={styles.hero}>
        <div className={styles.heroBg} />
        <img
          src={circleDecor}
          alt=""
          aria-hidden
          className={styles.decorRing}
        />

        <div className={styles.heroWrap}>
          <div className={styles.heroCopy}>
            <h1
              className={`${styles.h1} ${styles.grBold} ${styles.orangeGradientText}`}
            >
              Cityside Fiber SmartBiz
            </h1>
            <h2
              className={`${styles.h2} ${styles.grBold} ${styles.blue005282}`}
            >
              Internet Solutions Built for Small &amp; Medium Businesses
            </h2>

            <p
              className={`${styles.lead} ${styles.mtReg} ${styles.navy001334}`}
            >
              Cityside Fiber’s managed internet and WiFi solution for businesses
              allows you to focus on growth, productivity, and profitability.
              Our focus is on simplifying your IT needs and enhancing data
              security while fueling your business <br /> with the power of
              fiber.
            </p>

            <div className={styles.listWrap}>
              <h3
                className={`${styles.mtReg} ${styles.navy001334} ${styles.matchPrevParaSize}`}
              >
                SmartBiz Services Include:
              </h3>
              <ul className={styles.bullets}>
                <li>
                  <img src={mask} alt="" className={styles.liIcon} />
                  Dedicated Business Network
                </li>
                <li>
                  <img src={mask2} alt="" className={styles.liIcon} />
                  Network Security
                </li>
                <li>
                  <img src={mask3} alt="" className={styles.liIcon} />
                  Content Restrictions
                </li>
                <li>
                  <img src={mask4} alt="" className={styles.liIcon} />
                  Customized Customer Portal
                </li>
                <li>
                  <img src={mask5} alt="" className={styles.liIcon} />
                  Cellular Backup Connection
                </li>
                <li>
                  <img src={mask6} alt="" className={styles.liIcon} />
                  PCI DSS Secured Point of Sale Network
                </li>
                <li>
                  <img src={mask7} alt="" className={styles.liIcon} />
                  Security System and Camera Connection
                </li>
                <li>
                  <img src={mask8} alt="" className={styles.liIcon} />
                  Remarketing to your Customer Database
                </li>
                <li>
                  <img src={mask9} alt="" className={styles.liIcon} />
                  Cityside SmartBiz App Controller
                </li>
              </ul>
            </div>

            <div className={styles.heroNote}>
              Through the Cityside SmartBiz app, you choose how to prioritize
              multiple secure connections with just a few clicks, getting you
              quickly back to running your business.
            </div>
          </div>

          <div className={styles.heroArt}>
            <img
              src={heroPhoto}
              alt="Business owner at her shop"
              className={styles.heroPhoto}
            />
            <img
              src={phoneShot}
              alt="Cityside Fiber SmartBiz app screen"
              className={styles.heroPhone}
            />
          </div>
        </div>
      </section>

      {/* DEDICATED WIFI */}
      <section className={styles.diagram}>
        
        <div className={styles.diagramInner}>
          <div className={styles.diagramPhone}>
            <img
              src={wifiDiagram}
              alt="SmartBiz app dashboard on phone"
              loading="lazy"
            />
          </div>

          <div className={styles.diagramArt}>
          <h2
              className={`${styles.centerH2} ${styles.grBold} ${styles.orangeGradientText}`}
            >
              Dedicated WiFi Connections
            </h2>
            <img
              src={wifiDiagrm2}
              alt="POS, terminals, security camera and cellular backup connected to WiFi router"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* APP SHOWCASE */}
      <section className={styles.appShowcase}>
        <div className={styles.appHeader}>
          <h2 className={styles.brandTitle}>Cityside Fiber SmartBiz App</h2>
          <p className={styles.appSub}>Business Owner Controlled</p>
        </div>

        <div className={styles.appPhonesWrap}>
          <img
            src={appTitleArt}
            alt="Security, Customer Portal, Staff Network setup, Staff list and Guest WiFi"
            className={styles.appPhones}
            loading="lazy"
          />
        </div>
      </section>

      {/* STATS 1 */}
      <section className={styles.statsBlock}>
        <div className={styles.statsRow}>
          <div className={styles.statsImg}>
            <img
              src={wifiStat2}
              alt="People connected to WiFi on laptop and phone"
              loading="lazy"
            />
          </div>
          <div className={styles.statsCopy}>
            <h3 className={`${styles.grBold} ${styles.blue005282}`}>
              Customers Want WiFi
            </h3>

            <ul className={styles.bullets}>
              <li>
                <img src={mask10} alt="" className={styles.liIcon} />
                96% of consumers prefer shopping in businesses with free WiFi
              </li>
              <li>
                <img src={mask11} alt="" className={styles.liIcon} />
                100% of consumers depend on Secure WiFi connections and <br />{" "}
                Secure Business Transactions
              </li>
              <li>
                <img src={mask12} alt="" className={styles.liIcon} />
                61% of consumers look for WiFi in restaurants
              </li>
              <li>
                <img src={mask13} alt="" className={styles.liIcon} />
                55% of restaurant businesses report WiFi resulted in <br />{" "}
                higher customer sales per visit
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* STATS 2 */}
      <section className={styles.statsBlockAlt}>
        <div className={styles.statsRow}>
          <div className={styles.statsImg}>
            <img
              src={wifiStat1}
              alt="Customer using WiFi in a café"
              loading="lazy"
            />
          </div>
          <div className={styles.statsCopy}>
            <h3>Businesses Need a Secure Network</h3>
            <ul className={styles.bullets}>
              <li>
                <img src={mask14} alt="" className={styles.liIcon} />
                67% of small businesses say losing internet access decreases{" "}
                <br />
                productivity by 75%
              </li>
              <li>
                <img src={mask15} alt="" className={styles.liIcon} />
                82% of ransomware attacks are against small businesses
              </li>
              <li>
                <img src={mask16} alt="" className={styles.liIcon} />
                75% of SMBs would permanently close if hit by ransomware
              </li>
            </ul>
            <p>
              Residential broadband solutions may not meet Payment Card <br />
              Industry Data Security Standards (PCI DSS Compliance)
            </p>
          </div>
        </div>
      </section>

      {/* FORM */}
      <section className={styles.formBlock}>
        <div className="grid-12">
          <div className={styles.formContainer}>
          <div className="brandbar">
            <span className="title" id="smartbiz-form">Submit Your Interest</span>
          </div>
            <SmartBizForm />
          </div>
        </div>
      </section>
    </>
  );
}
